import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import ImportToolApp from "./ImportToolApp";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<ImportToolApp />);
